import { render } from "./BdAccountManagement.vue?vue&type=template&id=1518429e&scoped=true"
import script from "./BdAccountManagement.vue?vue&type=script&lang=js"
export * from "./BdAccountManagement.vue?vue&type=script&lang=js"

import "./BdAccountManagement.vue?vue&type=style&index=0&id=1518429e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1518429e"]])

export default __exports__